import { styled } from "@mui/material";

import { makeStyles } from "@mui/styles";

type SectionWrapProps = {
  gap: string;
};

export const SectionWrap = styled("div")<SectionWrapProps>(({ gap }) => ({
  width: "100%",
  display: "flex",
  gap: gap,
  flexWrap: "wrap",
  justifyContent: "flex-start",
  alignItems: "flex-start",
}));

const styles = makeStyles(() => ({
  modalEditItemBodyTitle: {
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "18px",
    color: "#475467",
    marginTop: "15px",
    marginBottom: "30px",
  },
  modalEditItemModeLabel: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    color: "#308CDB",
  },
  titleMode: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "16px",
    color: "#93A9BD",
  },
  titleModeActive: {
    color: "#308CDB !important",
  },
  icon: {
    marginRight: "5px",
    fontSize: "21px",
  },
  modalEditItemModeBox: {
    display: "flex",
    backgroundColor: "#F2F4F7",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    height: "54px",
    width: "88px",
    borderRadius: "12px",
    padding: "16px",
  },
  modalEditItemModeBoxActive: {
    backgroundColor: "#EDF5FB !important",
  },
  radioLabel: {
    "&:first-child": {
      "& span:first-child": {
        paddingLeft: 0,
      },
    },
    "& span:nth-child(2)": {
      fontWeight: "normal",
      color: "#465869",
    },
  },
  separator: {
    margin: "20px 0",
  },
  specialInstructionTitle: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "15px",
  },
  titleMaterial: {
    color: "#475467",
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    marginLeft: "16px",
  },
  quantityLinkedMaterial: {
    color: "#475467",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    letterSpacing: "0.4px",
    margin: "0px 8px",
    width: "10px",
    textAlign: "center",
  },
  iconButton: {
    padding: "0",
  },
  buttonAddMaterial: {
    width: "150px",
  },
  titleLinkedMaterial: {
    fontWeight: 600,
    marginLeft: "0px",
  },
  containerButtonMaterial: {
    marginTop: "24px",
  },
  containerTitle: {
    marginTop: "40px",
    marginBottom: "24px",
  },
  containerMaterialAdd: {
    gap: "12px",
    display: "flex",
    flexDirection: "column",
  },
  linkContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));

export default styles;
